const ESTIMATE_ENABLED_COUNTRY_CODES = new Set(['ES', 'FR', 'PT'])

export const isEstimateEnabled = (countryCode: string) =>
  ESTIMATE_ENABLED_COUNTRY_CODES.has(countryCode)
